<template>
    <content-mobile v-if="isMobileSize" v-bind="$attrs" />
    <content-pc v-else v-bind="$attrs" />
</template>

<script>
import pc from './pc';
import mobile from '../recent-listings/mobile';
export default {
    name: 'content-module',
    computed: {
        isMobileSize() {
            return this.platform.isMobile;
        }
    },
    components: {
        'content-pc': pc,
        'content-mobile': mobile
    }
};
</script>
